export default function MainDashboardContent ({ children, thin=false }) {

    return (
        <div className="py-4 px-4 w-full bg-slate-50 min-w-0">
            <div className={`${thin ? "max-w-4xl" : "max-w-full"} mx-auto`}>
             { children }
            </div>
        </div>
    )
}